import { createApp } from "vue";
import App from "./App.vue";
import router from "./routes";
import vuetify from "./plugins/vuetify";
import "@fontsource/lato/400.css";
import "@fontsource/lato/700.css";
import "@fontsource/lato/900.css";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "./index.css";

createApp(App).use(router).use(vuetify).mount("#app");
